require('./bootstrap');

window.Vue = require('vue');

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('itunes-search', require('./components/iTunesSearch.vue').default);
Vue.component('artist-search', require('./components/ArtistSearch.vue').default);
Vue.component('artist-match', require('./components/ArtistMatch.vue').default);
Vue.component('payment-form', require('./components/PaymentForm.vue').default);
Vue.component('upload-file', require('./components/UploadFile.vue').default);
Vue.component('upload-audio', require('./components/UploadAudio.vue').default);
Vue.component('upload-spatie', require('./components/UploadSpatie.vue').default);
Vue.component('current-audio', require('./components/CurrentAudio.vue').default);
Vue.component('single-audio', require('./components/SingleAudio.vue').default);
Vue.component('current-pictures', require('./components/CurrentPictures.vue').default);
Vue.component('current-spatie', require('./components/CurrentSpatie.vue').default);
Vue.component('date-picker', require('./components/DatePicker.vue').default);
Vue.component('text-editor', require('./components/TextEditor.vue').default);

const app = new Vue({
    el: '#app'
});


